module.exports = __webpack_public_path__ + "img/tq1.8595fb64.png";